import React, { Component } from "react";
import Nav from "./components/Nav";
import { authentication, authenticated, getSlugs } from "./services/auth";
import { initialization } from "./services/api";

import { withConfiguration } from "./services/config";
import Snackbar from "./components/Snackbar";
import Loader from "./components-utils/Loader";

import "./App.css";

export const AppContext = React.createContext();

class App extends Component {
  constructor() {
    super();
    authentication();
  }
  async componentDidMount() {
    await getSlugs();
    const auth = authenticated();
    const needInit = await initialization(auth.currentMerchant.code);
    this.setInit(needInit);
  }

  setInit = needInit => this.setState({ init: needInit });

  manageSnackbar = (
    message = "No Message",
    status = "success",
    autoHide = 5000
  ) => {
    this.setState(
      state => ({
        snackbar: {
          ...state.snackbar,
          message,
          status,
          autoHide
        }
      }),
      () => this.manageOpen(true)()
    );
  };

  manageOpen = isOpen => () => {
    this.setState(state => ({
      snackbar: { ...state.snackbar, opened: isOpen }
    }));
  };

  state = {
    langs: withConfiguration(config => config["langs"]),
    server: withConfiguration(config => config["server"]),
    init: undefined,
    setInit: this.setInit,
    snackbar: {
      message: "Message par défaut",
      status: "success",
      autoHide: 5000,
      opened: false,
      open: this.manageSnackbar,
      close: this.manageOpen(false)
    }
  };

  renderLoader() {
    return <Loader loading={true} />;
  }
  render() {
    const { langs, server, snackbar, init, setInit } = this.state;

    return init !== undefined ? (
      <AppContext.Provider value={{ langs, snackbar, server, setInit }}>
        <Nav key="nav" init={init} />
        <Snackbar
          key="Snackbar"
          opened={snackbar.opened}
          status={snackbar.status}
          message={snackbar.message}
          close={snackbar.close}
          autoHide={snackbar.autoHide}
        />
      </AppContext.Provider>
    ) : (
      this.renderLoader()
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js